import DialogRegistrarRecebimento from "../../../../screens/Financeiro/components/MIContasReceber/DialogRegistrarRecebimento"
import DialogAtualizacaoLimites from "../../../../screens/Financeiro/components/MIAnaliseDeCredito/DialogAtualizacaoLimites"
import DialogIncluirRecebimento from "../../../../screens/Financeiro/components/MIContasReceber/DialogIncluirRecebimento"
import { useModalStateContext } from "../../../../contexts/ModalStateContext"
import DialogRegistrarPagamento from "../../../../screens/Financeiro/components/MIContasPagar/DialogRegistrarPagamento"
import DialogIncluirPagamento from "../../../../screens/Financeiro/components/MIContasPagar/DialogIncluirPagamento"
import DialogIncluirLancamentoCCO from "../../../../screens/Financeiro/components/MIContaCorrenteConsumo/DialogIncluirLancamento"
import DialogIncluirLancamentoCaixaBanco from "../../../../screens/Financeiro/components/MICaixaBancos/DialogIncluirLancamento"
import DialogIncluirCheques from "../../../../screens/Financeiro/components/MICheques/DialogIncluirCheques"
import DialogApGlobal from "../../../../screens/Financeiro/components/MIApGlobal"
import SolicitarAnaliseCredito from "../../../../screens/Financeiro/components/SolicitarAnaliseCredito"
import { enqueueSnackbar } from "notistack"
import { useModalDetalheProcesso } from "../../../ModalContexts/ModalDetalheProcessoContext"
import DialogAdicionarCupom from "../../../../screens/Financeiro/components/MICupons/DialogAdicionarCupom"
import DialogAddEditSimulacao from "../../../../screens/Financeiro/components/MIFluxoCaixa/DialogAddEditSimulacao"

export default function ModaisFinanceiro() {

    const { openModal } = useModalDetalheProcesso()
    const { modais, handleToggleModal } = useModalStateContext()

    return (
        <>
            {
                modais.financeiro.solicitarAnaliseCredito &&
                <SolicitarAnaliseCredito
                    handleChangeProcesso={(item: string) => openModal(item)}
                    open={modais.financeiro.solicitarAnaliseCredito}
                    handleClose={() => {
                        handleToggleModal("financeiro", "solicitarAnaliseCredito", false)
                    }}
                    onCreate={(codigo: string) => {
                        handleToggleModal("financeiro", "solicitarAnaliseCredito", false)
                        enqueueSnackbar(`Solicitação de análise de crédito #${codigo} foi criada com sucesso!`, { variant: "success" })
                    }}
                    onFail={() => {
                        enqueueSnackbar(`Erro ao criar solicitação de análise de crédito`, { variant: "error" })
                    }}
                />
            }

            {
                modais.financeiro.registrarRecebimento &&
                <DialogRegistrarRecebimento
                    open={modais.financeiro.registrarRecebimento}
                    handleClose={() => {
                        handleToggleModal("financeiro", "registrarRecebimento", false)
                    }}
                />
            }

            {
                modais.financeiro.atualizacaoCredito &&
                <DialogAtualizacaoLimites
                    open={modais.financeiro.atualizacaoCredito}
                    handleClose={() => {
                        handleToggleModal("financeiro", "atualizacaoCredito", false)
                    }}
                />
            }
            {
                modais.financeiro.incluirRecebimento &&
                <DialogIncluirRecebimento
                    open={modais.financeiro.incluirRecebimento}
                    handleClose={() => {
                        handleToggleModal("financeiro", "incluirRecebimento", false)
                    }}
                />
            }
            {
                modais.financeiro.registrarPagamento &&
                <DialogRegistrarPagamento
                    open={modais.financeiro.registrarPagamento}
                    handleClose={() => {
                        handleToggleModal("financeiro", "registrarPagamento", false)
                    }}
                />
            }
            {
                modais.financeiro.incluirPagamento &&
                <DialogIncluirPagamento
                    open={modais.financeiro.incluirPagamento}
                    handleClose={() => {
                        handleToggleModal("financeiro", "incluirPagamento", false)
                    }}
                />
            }
            {
                modais.financeiro.incluirLancamentoCCO &&
                <DialogIncluirLancamentoCCO
                    open={modais.financeiro.incluirLancamentoCCO}
                    handleClose={() => {
                        handleToggleModal("financeiro", "incluirLancamentoCCO", false)
                    }}
                />
            }
            {
                modais.financeiro.incluirLancamentoCaixaBanco &&
                <DialogIncluirLancamentoCaixaBanco
                    open={modais.financeiro.incluirLancamentoCaixaBanco}
                    handleClose={() => {
                        handleToggleModal("financeiro", "incluirLancamentoCaixaBanco", false)
                    }}
                />
            }
            {
                modais.financeiro.incluirCheque &&
                <DialogIncluirCheques
                    open={modais.financeiro.incluirCheque}
                    handleClose={() => {
                        handleToggleModal("financeiro", "incluirCheque", false)
                    }}
                />
            }
            {
                modais.financeiro.apGlobal &&
                <DialogApGlobal
                    open={modais.financeiro.apGlobal}
                    handleClose={() => {
                        handleToggleModal("financeiro", "apGlobal", false)
                    }}
                />
            }
            {
                modais.financeiro.adicionarCupom &&
                <DialogAdicionarCupom
                    open={modais.financeiro.adicionarCupom}
                    handleClose={() => {
                        handleToggleModal("financeiro", "adicionarCupom", false)
                    }}
                />
            }
            {
                modais.financeiro.gerarSimulacao &&
                <DialogAddEditSimulacao
                    open={modais.financeiro.gerarSimulacao}
                    defaultValue={null}
                    handleClose={() => {
                        handleToggleModal("financeiro", "gerarSimulacao", false)
                    }}
                />
            }
        </>
    )
}
